import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHammer, FaExclamationTriangle } from 'react-icons/fa';
import SEO from '../Components/SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SEO title="404 - Page Not Found" description="Oops! The page you are looking for is under construction or doesn't exist." />
      <div className="container">
        <div className="not-found-content">
          <motion.div 
            className="illustration"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="crane">
              <div className="crane-arm"></div>
              <div className="crane-line"></div>
              <div className="crane-hook">
                <FaHammer className="hook-icon" />
              </div>
            </div>
            <div className="road-sign">
              <FaExclamationTriangle className="sign-icon" />
              <span>404</span>
            </div>
          </motion.div>
          
          <motion.h1 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Under <span>Construction</span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            Oops! The page you're looking for was either demolished or never built. 
            Let's get you back to safety.
          </motion.p>
          
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 1.2, type: 'spring', stiffness: 200 }}
          >
            <Link to="/" className="back-home-btn">
              Back to Home
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
